import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="About">
        About page in development
    </div>
    );
}

export default About;